import { Controller } from "stimulus"
import JSZip from "jszip"

export default class extends Controller {
  static targets = ["downloadLink", "createDownloadBtn", "loaderIcon"]

  async fetchAsBlob(url) {
    const response = await fetch(url)

    if (!response.ok) throw new Error(`Failed to fetch ${url}`)

    return response.blob()
  }

  addRemoteFilesToZip(zip) {
    return this.fileData.map(async data => {
      try {
        const blob = await this.fetchAsBlob(data.url)
        zip.file(data.filename, blob)
      } catch (error) {
        console.error(`Error fetching image: ${data.url}`, error)
      }
    })
  }

  async createDownload() {
    this.disableCreateDownloadBtn()

    const zip = new JSZip()

    await Promise.all(this.addRemoteFilesToZip(zip))

    zip.generateAsync({ type: "blob" }).then(zipBlob => {
      this.downloadLinkTarget.href = window.URL.createObjectURL(zipBlob)
      this.downloadLinkTarget.download = this.data.get("download-filename") || name
    })

    this.toggleActions()
  }

  get fileData() {
    return JSON.parse(this.data.get("file-data"))
  }

  disableCreateDownloadBtn() {
    this.createDownloadBtnTarget.disabled = true
    this.loaderIconTarget.style.display = "inline"
  }

  toggleActions() {
    this.createDownloadBtnTarget.style.display = "none"
    this.downloadLinkTarget.style.display = "inline-block"
  }
}
